import { useEffect } from "react"
import { AvatarInput } from "@/components"
import {
  currentUserResponseToUser,
  useUpdateAvatarApi,
} from "@/hooks/api/account"
import { useToast, useResourceUrl } from "@/hooks"
import { useStore } from "@/store"
import { User } from "@/types"
import { getUserFacingApiErrorMessage } from "@/lib/apiErrors"
import { useTranslation } from "react-i18next"

interface UserAvatarUploadProps {
  user: User
}

const UserAvatarUpload = ({ user }: UserAvatarUploadProps) => {
  const avatarUrl = useResourceUrl(user?.avatar)
  const { alertToast } = useToast()
  const { t } = useTranslation()
  const {
    error: updateAvatarError,
    data: updateAvatarRespData,
    fetchFn: updateAvatar,
  } = useUpdateAvatarApi()
  const setUserMe = useStore((state) => state.setUserMe)

  useEffect(() => {
    if (!updateAvatarError) return
    console.error("Failed to update avatar", updateAvatarError)

    alertToast({
      title: "Failed to update avatar",
      description: getUserFacingApiErrorMessage(
        updateAvatarError,
        t,
        updateAvatarRespData?.message || "Failed to update avatar"
      ),
    })
  }, [updateAvatarError, updateAvatarRespData, alertToast, t])

  const handleFileChange = (files: File[]) => {
    const selectedFile = files[0]
    const formData = new FormData()
    formData.append("avatar", selectedFile as File)
    updateAvatar({
      body: formData,
      callbackFn: (resp) => {
        if (!resp || !resp.data) return
        setUserMe(currentUserResponseToUser(resp.data))
      },
    })
  }

  return (
    <AvatarInput
      size="w-24 h-24"
      url={avatarUrl}
      name={user.name}
      subTitle={user.email}
      onChange={handleFileChange}
    />
  )
}

export default UserAvatarUpload
